import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { camelToTitle, getFullName } from '../../utils';

class DocumentFilters extends React.Component {
  // static PropTypes = {
  //   documents: PropTypes.array.isRequired,
  //   currentType: PropTypes.string.isRequired,
  //   currentTag: PropTypes.string.isRequired,
  //   currentUser: PropTypes.string.isRequired,
  //   onTagSelect: PropTypes.func.isRequired,
  //   onTypeSelect: PropTypes.func.isRequired,
  //   onUserSelect: PropTypes.func.isRequired,
  // }

  render () {
    const { documents, currentType, currentTag, currentUser } = this.props;
    const types = _.uniq(documents.map(doc => doc.documentType));
    const users = _.uniqBy(documents.map(doc => doc.createdUser), 'id').filter(x => x);  // isolated my doc list display problem a null in the users array for project ACEDOS501 that I was testing. .filter(x => x) removes the null -- got this code from https://stackoverflow.com/questions/41346902/filter-null-from-an-array-in-javascript
    const tags = _.flatten(documents.map(doc => doc.tags))
    const uniqTags = _.uniqBy(tags, 'label');

    return (
      <div className="list-filters boxed">
        <div className="filter-name">Document Types</div>
        <ul>
          { types.map((type, i) =>
            <li key={'typ' + i}
              onClick={() => this.props.onTypeSelect(type)}
              className={(type === currentType) ? 'active' : ''}
            >
              {camelToTitle(type)}
            </li>
          )}
        </ul>
        <div className="filter-name">Document Tags</div>
        <ul>
          { uniqTags.map((tag, i) =>
            <li key={'tag' + i}
              className={(tag.value === currentTag) ? 'active' : ''}
              onClick={() => this.props.onTagSelect(tag.value)}
            >
              {tag.label}
            </li>
          )}
        </ul>
        <div className="filter-name">Uploaded By</div>
        <ul>
          { users.map((user, i) =>
            <li key={'typ' + i}
              onClick={() => this.props.onUserSelect(user.id)}
              className={(user.id === currentUser) ? 'active' : ''}
            >
              {getFullName(user)}
            </li>
          )}
        </ul>
      </div>
    )
  }
}

DocumentFilters.propTypes = {
  documents: PropTypes.array.isRequired,
  currentType: PropTypes.string.isRequired,
  currentTag: PropTypes.string.isRequired,
  currentUser: PropTypes.string.isRequired,
  onTagSelect: PropTypes.func.isRequired,
  onTypeSelect: PropTypes.func.isRequired,
  onUserSelect: PropTypes.func.isRequired
};

export default DocumentFilters;